@media (min-width: 768px){:host{display:flex;flex-direction:column;height:100%}#sidebarCollapse{overflow-y:auto;flex:1 1 auto}}
/*# sourceMappingURL=main-menu.component-LCEAVMG6.css.map */
